"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var requestConfig = function (_a) {
    var _b = _a.method, method = _b === void 0 ? 'post' : _b, API = _a.API, token = _a.token, language = _a.language, data = _a.data, params = _a.params;
    var result = {
        method: method,
        url: API,
        responseType: 'json',
        headers: {
            token: token,
            language: language,
        },
        data: data,
        params: params,
    };
    if (!token) {
        delete result.headers.token;
    }
    if (!language) {
        delete result.headers.language;
    }
    return axios_1.default.request(result);
};
exports.default = requestConfig;
